import React from 'react';

import { makeClassNames } from '../../utils/styles';
import t from '../../labels/labelling-utils';
import './new-posts-title.scss';

export interface NewPostsTitleProps {
  count: number;
}

const cn = makeClassNames({
  NewPostsTitle: 'new-posts-title',
});

const NewPostsTitle: React.FC<NewPostsTitleProps> = ({ count }) => (
  <div className={cn.NewPostsTitle}>
    {count} {count === 1 ? t('new.posts.title.singular') : t('new.posts.title.plural')}
  </div>
);

export default NewPostsTitle;
